"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const header_1 = __importDefault(require("./components/header"));
const pagetop_1 = require("./components/pagetop");
const scroll_animation_1 = __importDefault(require("./components/scroll-animation"));
const toggle_1 = require("./components/toggle");
const more_list_1 = require("./components/more-list");
const dropdown_1 = require("./components/dropdown");
const modal_1 = require("./components/modal");
const fixed_banner_1 = __importDefault(require("./components/fixed-banner"));
const slider_companies_1 = require("./components/slider-companies");
const slider_article_main_1 = require("./components/slider-article-main");
window.addEventListener("DOMContentLoaded", () => {
    (0, header_1.default)();
    (0, pagetop_1.pageTop)();
    (0, toggle_1.toggleDetails)();
    (0, more_list_1.moreList)();
    (0, dropdown_1.dropdown)();
    (0, modal_1.modalDialog)();
    slider_companies_1.sliderCompanies.configure();
    slider_article_main_1.sliderArticleMain.configure();
});
window.addEventListener("load", () => {
    (0, scroll_animation_1.default)();
    (0, fixed_banner_1.default)();
});
